import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { Subject, Subscription } from 'rxjs';
import { BvrtResult, EvaluationCallBackResult, GameResult } from 'src/app/games/shared/gameResult';
import { AuthenticationService } from 'src/app/services/authentication.service';
import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import { loadMessages, locale } from 'devextreme/localization';
import { LoginUser } from 'src/app/services/webapiclient.service';
import { GameService } from 'src/app/games/services/game.service';
import { FreehandDrawingDirective } from 'src/app/drawing/freehand-drawing.directive';

@Component({
    selector: 'app-bvrt-eva',
    templateUrl: './bvrt-eva.component.html',
    styleUrl: './bvrt-eva.component.scss',
    standalone: false
})

export class BvrtEvaComponent implements OnInit, OnDestroy {
  @Input() wrResult: BvrtResult;
  @Input() gameId: number;
  @Input() subType: string;
  @Input() needSaveSubject: Subject<any>;
  @Output() closeEvaluationEvent = new EventEmitter<EvaluationCallBackResult>();

  // Freehand Drawing Area
  @ViewChild(FreehandDrawingDirective, { static: false }) _freehand: FreehandDrawingDirective;


  private translSubs$: Subscription;
  private needSaveSubject$: Subscription;

  //Képek útvonala
  srcRoot = "../assets/images//bvrt/";
  srcPath: string;

  stylingMode = "filled"
  currentUser: LoginUser;
  error: any;
  dateFormat: string;

  showInterval: any;
  loading: boolean = false;

  gameResult: GameResult = <GameResult>{};
  callBackResult: EvaluationCallBackResult = <EvaluationCallBackResult>{};


  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translation: L10nTranslationService,
    private authenticationService: AuthenticationService,
    public gameService: GameService

  ) {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
      'hu': JSON.parse(huMessages)
    });
  }


  ngOnInit(): void {
    this.needSaveSubject$ = this.needSaveSubject.subscribe(event => {
      // called when the notifyChildren method is
      // called in the parent component
      this.saveData(event);
      //console.log(event);
    });

    this.srcPath = this.srcRoot + this.wrResult.words[1].toLocaleLowerCase() + "/" + this.subType + ".png";

    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
        this.dateFormat = this.translation.translate('Core.DateFormat');
      });

    this.currentUser = this.authenticationService.currentUserValue;

    //Kirajzoljuk az ábrát
    this.drawShape();

    if (this.currentUser) {
      //this.evaluation = true;
    }
  }

  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
    if (this.needSaveSubject$) {
      this.needSaveSubject$.unsubscribe();
    }
  }

  drawShape() {
    this.loading = true;
    this.showInterval = setInterval(() => {
      if (this._freehand && this._freehand.readyToDraw && this._freehand.backgroundReady) {
        this.showDrawing();
        clearInterval(this.showInterval);
        this.loading = false;
      }
    }, 25); // Egy tized másodpercenként számolunk vissza.    

  }

  onShown() {
    setTimeout(() => {
      this.loading = false;
    }, 15000);
  }

  /**
  * Kirajzoljuk az órát
  */
  showDrawing() {
    this._freehand.clear();

    let j: number;
    let m: number = this.wrResult.freehandX.length;
    for (j = 0; j < m; ++j) {
      let n: number = this.wrResult.freehandX[j].length;
      if (n < 3) {
        continue;
      }
      let i: number;
      this._freehand.beginStrokeAt(this.wrResult.freehandX[j][0], this.wrResult.freehandY[j][0], false);
      for (i = 1; i < n - 1; ++i) {
        this._freehand.updateStroke(this.wrResult.freehandX[j][i], this.wrResult.freehandY[j][i]);
      }
      this._freehand.endStrokeAt(this.wrResult.freehandX[j][n - 1], this.wrResult.freehandY[j][n - 1]);

    }

  }  

  saveData(direction) {

    this.error = null;
    let tmpResult = 1;


    // A szerver számára összeállítjuk az adatokat.
    this.wrResult.numbers1[0] = this.wrResult.numbers1[0] ? 1 : 0;
    this.wrResult.numbers1[1] = this.wrResult.numbers1[1] ? 1 : 0;
    this.wrResult.numbers1[2] = this.wrResult.numbers1[2] ? 1 : 0;
    this.wrResult.numbers1[3] = this.wrResult.numbers1[3] ? 1 : 0;
    this.wrResult.numbers1[4] = this.wrResult.numbers1[4] ? 1 : 0;
    this.wrResult.numbers1[5] = this.wrResult.numbers1[5] ? 1 : 0;
    this.wrResult.numbers1[6] = this.wrResult.numbers1[6] ? 1 : 0;
    this.wrResult.numbers1[7] = this.wrResult.numbers1[7] ? 1 : 0;
    this.wrResult.numbers1[8] = this.wrResult.numbers1[8] ? 1 : 0;

    //csak a hibátlan rajzokra adunk 1 pontot
    let error = this.wrResult.numbers1.filter(f => f == 1).length;
    if(error>0) tmpResult = 0;    

    this.wrResult.evaluation = true;
    this.gameResult.result = tmpResult;
    this.gameResult.resultDetails = JSON.stringify(this.wrResult);
    this.gameResult.subType = this.subType;
    this.gameResult.completed = true;
    this.gameResult.id = this.gameId;

    // Elküldjük a szerverre az adatokat.
    this.gameService.send(this.gameResult).subscribe(
      () => {
        //Jelezzük a hívónak, hogy vége a kiértékelésnek
        this.callBackResult.direction = direction;
        this.callBackResult.result = this.gameResult.result;
        this.closeEvaluationEvent.emit(this.callBackResult);
      }
    );

  }


}
